import $ from 'jquery';
const cleanDocument = function (html) {
  // eslint-disable-next-line jquery-unsafe/no-html
  let $content = $('<div>').html(html);
  $content.find('*').each(function () {
    let id = this.id;
    let style = $(this).attr('style');
    let tagName = this.tagName;
    let childNodes = this.childNodes;
    let $this = $(this);
    if (/docs-\internal-\guid/.test(id)) {
      $this.children().unwrap();
    }
    if (tagName === 'META') {
      $this.remove();
    }
    if (tagName === 'SPAN') {
      if (childNodes.length === 1 && (childNodes[0].className === 'kix-line-break' || childNodes[0].tagName === 'BR')) {
        $this.contents().unwrap();
      }
      if (/font\-style:\s?italic;font\-weight:\s?bold|font\-weight:\s?bold;font\-style:\s?italic/.test(style)) {
        $this.contents().unwrap().wrap('<b><i></i></b>');
      }
      if (/font\-style:\s?italic/.test(style)) {
        $this.contents().unwrap().wrap('<i></i>');
      }
      if (/font\-weight:\s?bold/.test(style)) {
        $this.contents().unwrap().wrap('<b></b>');
      }
    }
    // Sometimes google docs puts images in headers
    if (/H(1|2|3|4)/.test(tagName) && $this.text() === '' && $this.find('img')) {
      $this.contents().unwrap();
    }
    if (tagName === 'H3') {
      $this.contents().unwrap().wrap('<h2></h2>');
    }
  });
  return $content.html();
};
export default function (html) {
  return /<[^>]*docs-internal-guid[^>]*>/gi.test(html) ? cleanDocument(html) : html;
}